import { LoadingContainer } from 'peach/components'
import { useHistory, useParams } from 'peach/router'

import { DynamicForm, Page, PageHeader } from 'core/components'
import { useLoanTapeCreate } from 'core/types'
import { loanTapeSchema } from 'core/utils/generated/formSchemas'

const CreateLoanTape = () => {
  const history = useHistory()
  const { companyId } = useParams<{ companyId?: string }>()

  const { mutateAsync: createLoanTape } = useLoanTapeCreate({ companyId })

  return (
    <LoadingContainer isLoading={false}>
      <Page variant='full'>
        <PageHeader title='Create Loan Tape' />
        <DynamicForm
          data={{}}
          fieldEditMode='all'
          omitFields={['id', 'createdAt', 'updatedAt', 'deletedAt', 'object']}
          onSubmit={async (payload: any) => {
            const res = await createLoanTape(payload)
            const id = (res as any)?.data?.id as string | undefined
            if (id) {
              history.push(`/companies/${companyId}/loan-tapes/${id}`)
            } else {
              history.push(`/companies/${companyId}/loan-tapes`)
            }
          }}
          schema={loanTapeSchema}
          submitText='Create Loan Tape'
          validationRules={{
            loanTapeTypeId: [
              (v: unknown) =>
                (typeof v === 'string' && v.trim().length > 0) ||
                'loanTapeTypeId is required',
            ],
            sftpHostname: [
              (v: unknown) =>
                (typeof v === 'string' && v.trim().length > 0) ||
                'sftpHostname is required',
            ],
          }}
        />
      </Page>
    </LoadingContainer>
  )
}

export default CreateLoanTape
